import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-message',
  templateUrl: './cookie-message.component.html',
  styleUrls: ['./cookie-message.component.sass']
})
export class CookieMessageComponent implements OnInit {

  public isShowMessage: boolean = false;

  constructor() { }

  ngOnInit() {
    
    this.checkIfNeedToDisplay()
  }

  public checkIfNeedToDisplay(){
    this.hideCookieMessage();
    
    if ( this.getCookie('cookie_notification') == '1' ) {  
      this.hideCookieMessage();
    } else {
      this.showCookieMessage()
    }
  }

  public onAgreedCoockieButtonClick(){
    document.cookie = "cookie_notification=1; domain=.ukrposhta.ua";
    document.cookie = "cookie_notification=1";
    this.hideCookieMessage();
  }

  public getCookie( cname: string ): string {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
    }
    return "";
  }


  public hideCookieMessage(){
    this.isShowMessage = false ;
  }

  public showCookieMessage(){
    this.isShowMessage = true ;
  }

}
